module.exports = __webpack_public_path__ + "img/preventative_health.9ee4379f.svg";